import React from 'react';
import Lookup from '../componentes/select2';
import { autobind } from 'core-decorators';

@autobind
class SeparadorNumerico extends React.Component {
  render() {
    return <Lookup labelKey="descricao" valueKey="id" url="/SeparadorNumericoLookup" clearable={false} {...this.props} />;
  }
}

export default SeparadorNumerico;
